import {createStore, applyMiddleware} from 'redux';
import {persistStore, persistReducer} from 'redux-persist';
import LocalStorage from 'redux-persist/lib/storage';
import {createLogger} from 'redux-logger';

// Imports: Redux
import rootReducer from '../reducers/index';

const persistConfig = {
  // Root
  key: 'throo_admin',

  // Storage Method (React Native)
  storage: LocalStorage,

  // Whitelist (Save Specific Reducers)
  whitelist: ['UserConfigReducer'],
  
  // Blacklist (Don't Save Specific Reducers)
  blacklist: [],
};

// Middleware: Redux Persist Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Redux: Store
const store = createStore(persistedReducer, applyMiddleware(createLogger()));

// Middleware: Redux Persist Persister
let persistor = persistStore(store);

export {store, persistor};
